import TabHandler, { registerTabHandler } from './utils/TabHandler';
import TabViewState, {
    TabType,
    PrimaryReadingPaneTabViewState,
    SecondaryReadingPaneTabViewState,
    OverflowTabViewState,
    ComposeTabViewState,
} from './store/schema/TabViewState';
import findTabByData from './utils/findTabByData';
import getActiveContentTab from './utils/getActiveContentTab';
import { getStore, primaryTab } from './store/tabStore';
import { LazyAction, LazyModule } from 'owa-bundling';
import SecondaryReadingPaneTabData from './store/schema/SecondaryReadingPaneTabData';

import './actions/addChatTabMutator';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "TabView" */ './lazyIndex'));

export let lazyActivateTab = new LazyAction(lazyModule, m => m.activateTab);
export let lazyAddTab = new LazyAction(lazyModule, m => m.addTab);
export let lazyCloseTab = new LazyAction(lazyModule, m => m.closeTab);
export let lazySetTabIsShown = new LazyAction(lazyModule, m => m.setTabIsShown);

export {
    TabHandler,
    TabType,
    PrimaryReadingPaneTabViewState,
    SecondaryReadingPaneTabViewState,
    OverflowTabViewState,
    ComposeTabViewState,
    TabViewState,
    findTabByData,
    getActiveContentTab,
    getStore,
    primaryTab,
    registerTabHandler,
    SecondaryReadingPaneTabData,
};

import './actions/activateTabOrchestrator';
